import { GET_PREVIOUSLY_ORDERED_MENU_MEALS_RESPONSE } from 'lib/constants/v3Actions';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PREVIOUSLY_ORDERED_MENU_MEALS_RESPONSE:
      return {
        ...state,
        [action.params.menuSlug]: {
          meals: action.response.meals,
          isFetched: true,
        },
      };
    default:
      return state;
  }
};

export const selectPreviouslyOrderedMenuMeals = (state, menuSlug) => state[menuSlug]?.meals || [];
export const selectPreviouslyOrderedMenuMealsIsFetched = (state, menuSlug) =>
  state[menuSlug]?.isFetched || false;
